"use client";

import React from "react";
import Image from "next/image";

const OfficeHeroBanner: React.FC = () => {
  return (
    <section
      className="relative w-full bg-gray-900 pt-48  pb-16"
      role="region"
      aria-labelledby="office-hero-heading"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <Image
          src="/images/custom_images_office_2.webp"
          alt="Office Image"
          fill
          className="object-cover object-center"
          sizes="100vw"
          quality={80}
        />
        <div className="absolute inset-0 bg-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-8 lg:px-12 flex flex-col items-center text-white">
        <h1
          id="office-hero-heading"
          className="
            inline-block text-center
            text-4xl sm:text-5xl lg:text-6xl font-bold text-white
            after:content-[''] after:block after:w-[250px] after:h-[4px] after:mx-auto after:my-6
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)] 
          "
        >
          Our Dental Office in Astoria NY
        </h1>
      </div>
    </section>
  );
};

export default OfficeHeroBanner;